import { SVGPureIcon } from '@/ui';
import { Form, Input } from 'antd';
import DragUpload from './dragUpload';
import Tooltip from '@/ui/tooltip';
import { useCallback, useMemo, useRef, useEffect } from 'react';
import store from '../store';
import { HelpOther } from '@/common/helper';

const { TextArea } = Input;

const Prompt = ({ form, height }) => {
  const watcherServerlist = Form.useWatch('server_list', form);
  const ref = useRef(null);
  const isShowAddPrompt = useMemo(() => {
    let flag = false;
    ref.curent = false;
    watcherServerlist?.forEach(id => {
      const item = store.getCurrentMcp(id) || {};
      if (item.server_name == 'get-agent-prompt') {
        flag = true;
        ref.curent = true;
        return;
      }
    });
    return flag;
  }, [watcherServerlist]);

  // useEffect(() => {
  //   const list = form.getFieldValue('prompt_list') || []; // 获取当前列表
  //   if (ref.curent) {
  //     form.setFieldsValue({
  //       prompt_list: list, // 手动添加一项
  //     });
  //   } else {
  //     form.setFieldsValue({
  //       prompt_list: [list?.[0]], // 手动添加一项
  //     });
  //   }
  // }, [ref.curent]);

  const handleAdd = () => {
    const list = form.getFieldValue('prompt_list') || []; // 获取当前列表
    if (list.length >= 4) {
      HelpOther.toast('您已超出新增上限');
      return;
    }
    form.setFieldsValue({
      prompt_list: [...list, ''], // 手动添加一项
    });
    const $ele = document.getElementById('promptCard');
    setTimeout(() => {
      $ele.scrollTo({ top: $ele.scrollHeight, behavior: 'smooth' });
    }, 50);
  };

  useEffect(() => {
    if (isShowAddPrompt) {
      const $ele = document.getElementById('promptCard');
      setTimeout(() => {
        $ele.scrollTo({ top: $ele.scrollHeight, behavior: 'smooth' });
      }, 50);
    }
  }, [isShowAddPrompt]);

  const parseAdd = useCallback(
    text => {
      const list = form.getFieldValue('prompt_list') || []; // 获取当前列表
      const emptyStrIdx = list.findIndex(item => item == '');

      if (emptyStrIdx > -1) {
        list[emptyStrIdx] = text;
        form.setFieldsValue({
          prompt_list: [...list], // 手动添加一项
        });
      } else {
        form.setFieldsValue({
          prompt_list: [...list, text], // 手动添加一项
        });
      }
    },
    [ref.curent]
  );

  return (
    <div className="create-prompt-list">
      <div className="h-32px flex items-center justify-between">
        <div>
          <span className="text-16px  font-medium text-[#000]">
            智能提示词（Prompt）
          </span>
          {/* <span className="ml-10px text-[rgba(0,0,0,0.5)] text-12px">
            支持输入/上传多个提示词，用于智能体调用
          </span> */}
        </div>

        {/* <DragUpload parseAdd={parseAdd} className="w-112px h-32px"></DragUpload> */}
      </div>
      <div className="textarea-wrapper mt-12px">
        <Form.Item className="textarea-item" label="系统提示词" name="intro">
          <TextArea
            className="text-14px nw-scrollbar-thin"
            // autoSize={{ minRows: 4, maxRows: 10 }}
            style={{
              // height: '80px',
              resize: 'none',
              padding: '10px 12px',
              height: `${height}px`,
            }}
            placeholder="示例：你是一位经验丰富的研究员，善于在各个领域搜索数据，解读报告，并提供研究成果。"
          />
        </Form.Item>
      </div>

      <Form.List name="prompt_list">
        {(fields, { add, remove }, { errors }) => (
          <>
            {fields?.map((field, index) => {
              console.log('field is', field);
              return (
                <div className="textarea-wrapper ">
                  <Form.Item
                    required={false}
                    key={field.key}
                    {...field}
                    label={
                      <div className="flex items-center add-item justify-between text-14px">
                        <div>提示词0{index + 1}</div>

                        {index != 0 ? (
                          <div>
                            <Tooltip title="删除当前prompt">
                              <span className="w-28px h-28px flex items-center rounded-8px justify-center block hover:bg-[rgba(0,0,0,0.06)]">
                                <SVGPureIcon
                                  onClick={e => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    if (fields.length <= 1) {
                                      return;
                                    }
                                    remove(field.name);
                                  }}
                                  name="icon_delete"
                                  size={16}
                                  className="text-primary-opacity text-opacity-50 hover:text-opacity-100"
                                />
                              </span>
                            </Tooltip>
                          </div>
                        ) : null}
                      </div>
                    }
                    className={`textarea-item ${index == fields.length - 1 ? 'dynamic-ask-mb' : ''} relative dynamic-ask-item`}
                  >
                    <TextArea
                      className="text-14px nw-scrollbar-thin "
                      style={{
                        // height: '80px',
                        resize: 'none',
                        padding: '10px 12px',
                        height: `${height}px`,
                      }}
                      placeholder="提示词用例：你是一名资深研究分析师，具备将复杂信息提炼为清晰见解的能力。你需要运用专业的分析方法和工具，从海量的行业数据、企业财报、政策文件、市场调研报告等多维度信息中，筛选出核心要点，以逻辑严谨、条理清晰、语言精炼的方式呈现你的研究成果，确保能够为决策者提供精准、有价值的参考依据。"
                    />
                  </Form.Item>
                </div>
              );
            })}
          </>
        )}
      </Form.List>
      {isShowAddPrompt ? (
        <div
          onClick={() => {
            handleAdd();
          }}
          className="flex cursor-pointer custom-boxhover h-44px border-dashed border-1px border-[#000] items-center justify-center rounded-8px bg-[#fff]"
        >
          <SVGPureIcon name="prompt_add" size={16} />
          <span className="ml-10px text-16px font-medium text-[#000]">
            添加提示词
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default Prompt;
